import { observable } from "mobx";
import { BranchViewEventModel } from "../BranchViewEventModel"

/**
 * LeagueEventsCompositeModel defines event for racing braches.
 *
 * @typedef LeagueEventsCompositeModel
 * @type {Object}
 * @property {leagueName} Title of current league
 * @property {hasLiveStream} Boolean identifier if has live stream
 * @property {events} BranchViewEventModel[] Branch View events for current league
 */

export class LeagueEventsCompositeModel {
    id : string;
    leagueName: string;
    @observable hasLiveStream: boolean;
    @observable events: BranchViewEventModel[];

    constructor(source: LeagueEventsCompositeModel) {
        this.id = source.id
        this.leagueName = source.leagueName;
        this.hasLiveStream = source.hasLiveStream;
        this.events = source.events;
    }
}